import React, { useState } from "react";
import logo from "../../images/managekaro logo.png";
import resetLogo from "../../images/resetlogo.png";
import { Button, TextField, Typography } from "@mui/material";
import { Redirect, useHistory } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Repo from "../../Repository/Repo";

const schema = yup
  .object()
  .shape({
    email: yup.string().email().required("Email is Required"),
  })
  .required();

function ResetPassword() {
  const [state, setState] = useState({
    loading: false,
    email: "",
    emailEntered: false,
  });
  const history = useHistory();

  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  const sendEmail = async (email) => {
    setState((prevState) => ({ ...prevState, loading: true }));
    let { data } = await Repo.user({
      request: {
        method: "getUser",
        data: {
          email: email.email,
        },
      },
    });
    if (data.response.status.statusCode == 500) {
      setState((prevState) => ({ ...prevState, loading: false }));
      toast.configure();
      toast.info("Email Not Found", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else {
      let user = data.response.data.user;
      let userInfo = {
        _id: user._id,
        _rev: user._rev,
        name: user.name,
        email: user.email,
        imgURL: user.imgURL,
        company_name: user.company_name,
        company_code: user.company_code,
        created_at: user.created_at,
        address: user.address,
        reset_password_token: user._rev,
      };

      await Repo.user({
        request: {
          method: "updateUser",
          data: {
            _id: user._id,
            user: { ...userInfo },
          },
        },
      });
      await Repo.email({
        request: {
          method: "sendPasswordReset",
          data: {
            to: email.email,
            from: "bakra@qurbaniapp.com",
            user: email.email,
            sender: "HardwarePakistan",
            link:
              "https://managekaro.org/resetlink/" +
              user._id +
              "/" +
              user._rev,
          },
        },
      });
      setState((prevState) => ({ ...prevState, loading: false }));
      toast.configure();
      toast.success("An autogenerated link has been sent to your account", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
    reset();
    history.push("/inventory/login");
  };

  if (localStorage.getItem("tokenType") === "user") {
    return <Redirect to="/dashboard" />;
  } else if (localStorage.getItem("tokenType") === "admin") {
    return <Redirect to="/admin" />;
  }

  return (
    <div className="half-grid">
      <div>
        <div className="center">
          <img className="logoiconlg" src={logo} alt="logo"></img>
          <div>
            <h1 className="Title-lg regular">
              The Best Solution For All Your Inventory Needs
            </h1>
            <h2 className="dark-grey regular">
              Forgot password? Don't worry, just enter your email below...
            </h2>
          </div>

          <div className="form-container">
            <TextField
              autoFocus
              variant="outlined"
              label="Email"
              name="email"
              type="email"
              fullWidth
              {...register("email")}
            />
            <Typography style={{ color: "red" }}>
              {errors.email?.message}
            </Typography>
            <ClipLoader size={50} color={"#4DAF51"} loading={state.loading} />
            {!state.loading && (
              <Button
                variant="contained"
                onClick={handleSubmit(sendEmail)}
                style={{
                  background: "#4EAF51",
                  marginTop: "20px",
                  color: "white",
                }}
              >
                NEXT
              </Button>
            )}
          </div>
        </div>
      </div>

      <div className="center inventorylogo">
        <img id="reset-main" src={resetLogo} alt="logo"></img>
      </div>
    </div>
  );
}

export default ResetPassword;
